module.exports = __webpack_public_path__ + "img/cooperative0_logo5.43c07230.jpg";